import React, { useContext, useMemo } from 'react';
import { MenuProps } from '@fuxi/eevee-ui';
import { useLoginInfo } from '@fuxi/eevee-hooks';
import { useLoginHelper } from 'common/hooks';
import { useAppSelector } from '@/hooks';
import { selectIsAdmin, selectUserInfo } from '@/store/user';
import { FormattedRes } from 'ahooks/lib/useCountDown';

type Props = { shouldIgnoreLogin?: boolean };

export type CustomLoginDetail = {
  isLogin: boolean;
  logoutMenus: MenuProps['items'];

  countdown?: number;
  formatted?: FormattedRes;
  sendCoding?: boolean;
  sendCode: any;

  login: any;
  loading: any;
  mailVerify: any;
  userInfo: any;
  isAdmin: boolean;
};
const NO_PROVIDER = {};
const CustomLoginInfoContext = React.createContext(NO_PROVIDER);

const CustomLoginInfoProvider: React.FC<React.PropsWithChildren<Props>> = ({ shouldIgnoreLogin, children }) => {
  const eeveeLoginInfo = useLoginInfo();
  const userInfo = useAppSelector(selectUserInfo);
  const isAdmin = useAppSelector(selectIsAdmin);
  const { handleLogOut: eeveeHandleLogout } = eeveeLoginInfo;

  const { isLogin, loading, login, emailLogin, logout } = useLoginHelper();

  const logoutMenus: MenuProps['items'] = useMemo(
    () => [
      {
        key: 'logout',
        label: '登出',
        onClick: () => {
          logout();
          eeveeHandleLogout();
        },
      },
    ],
    [],
  );

  return (
    <CustomLoginInfoContext.Provider
      value={{
        ...eeveeLoginInfo,
        login,
        loading,
        mailVerify: emailLogin,
        isLogin: isLogin || eeveeLoginInfo.isLogin,
        logoutMenus,
        userInfo,
        isAdmin,
      }}>
      {children}
    </CustomLoginInfoContext.Provider>
  );
};

const useCustomLoginInfoContext = () => {
  const value = useContext(CustomLoginInfoContext);

  if (value === NO_PROVIDER) {
    // eslint-disable-next-line no-console
    console.warn(`useLoginInfoContext must be wrapped with LoginInfoProvider`);
  }

  return value as CustomLoginDetail;
};

export { CustomLoginInfoProvider, useCustomLoginInfoContext };
